import { Button } from 'primereact/button'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Crud from '../components/form/Crud'
import roleProcessor from '../processor/roleProcessor'
import truongProcessor from '../processor/truongProcessor'
import userProcessor from '../processor/userProcessor'

function User() {
  const moduleName = 'người dùng'
  const processor = userProcessor

  const [roles, setRoles] = useState([])
  const [schools, setSchools] = useState([])
  const toast = useSelector((store) => store.notify.toast)

  const getRoles = async () => {
    const rs = await roleProcessor.getAll()
    setRoles([{ id: 0, name: 'Người dùng' }, ...rs])
  }
  const init = () => {
    getRoles()
  }

  useEffect(async () => {
    init()
    const rs = await truongProcessor.getAll()
    setSchools([{ id: 0, name: 'Phòng giáo dục' }, ...rs])
  }, [])

  const column = [
    { value: 'userName', name: 'Tên đăng nhập', sortable: true },
    { value: 'fullname', name: 'Họ và tên', sortable: true },
    {
      value: 'truongId',
      name: 'Trường',
      sortable: true,
      render: (data) => {
        const schoolItem = schools.find((item) => item.id === data.truongId)
        return schoolItem ? schoolItem.name : 'Phòng giáo dục'
      },
    },
    {
      value: 'roleId',
      name: 'Quyền',
      sortable: true,
      render: (data) => {
        const roleItem = roles.find((item) => item.id === data.roleId)
        return roleItem ? roleItem.name : ''
      },
    },
  ]
  const config = {
    fields: (account) =>
      !account.id
        ? ['userName', 'truongId', 'roleId', 'fullname', 'email', 'password']
        : ['userName', 'truongId', 'roleId', 'fullname', 'email'],
    col: { roleId: 4, fullname: 4, email: 4, password: 12 },
    name: {
      userName: 'Tên đăng nhập',
      truongId: 'Trường',
      roleId: 'Quyền',
      fullname: 'Họ và tên',
      email: 'Email',
      password: 'Mật khẩu',
    },
    maxLength: { fullname: 50, userName: 20, password: 20 },
    minLength: { userName: 4, password: 6 },
    options: { roleId: roles, truongId: schools },
    types: { roleId: 'select', truongId: 'select', password: 'password' },
    disable: (account) => (!account.id ? [] : ['userName']),
    required: ['userName', 'fullname', 'password'],
  }

  return (
    <>
      <Crud
        processor={processor}
        moduleName={moduleName}
        column={column}
        config={config}
        chucNang={(data) => {
          return (
            <>
              <Button
                icon="pi pi-refresh"
                className="p-button-rounded mr-2"
                onClick={async () => {
                  const rs = await processor.resetPassword(data.id)
                  toast({ type: rs.isSuccess ? 'success' : 'error', message: rs.data })
                }}
                tooltip="Reset mật khẩu"
                tooltipOptions={{ position: 'top' }}
              />
            </>
          )
        }}
      />
    </>
  )
}

export default withRouter(User)
